import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=b25106c8&scoped=true&"
import script from "./ErrorComponent.vue?vue&type=script&lang=ts&"
export * from "./ErrorComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorComponent.vue?vue&type=style&index=0&id=b25106c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25106c8",
  null
  
)

export default component.exports